import { FormattedMessage } from 'react-intl';
import DashboardLayout from '../layout/Dashboard';
import { CertificatesTable } from 'components/pages/certificateManagement/CertificatesTable';
import { NoRights } from '../../components/layout/Permissions/NoRights';
import { ACL } from '../../config/constants';
import { Messages } from '../../components/layout/Messages/Messages';
import React from 'react';
import { NOTIFICATION_LIST_CERTIFICATES, NOTIFICATION_CERTIFICATE_ACTIONS } from '../../config/notifications';
import {
  PageHeader,
  PageSurface,
  PageWorkspace
} from '../../components/layout/Workspace';
import './CertificateManagement.scss';

function CertificateManagement(props) {

  return (
    <DashboardLayout
      pageTitle={<FormattedMessage id="app.dashboard.page_title" />}
      workspace
      {...props}
    >
      <PageWorkspace className="certificates-list-workspace">
        <PageHeader title={<FormattedMessage id="pages.certificateManagement.title" />}/>
        <div className="certificates-list-notifications">
          <Messages notificationId={NOTIFICATION_LIST_CERTIFICATES}/>
          <Messages notificationId={NOTIFICATION_CERTIFICATE_ACTIONS}/>
        </div>
        <PageSurface className="certificates-list-surface">
          {ACL.CLIENT.DOCUMENTS.LIST.hasAccess() ? <CertificatesTable/> : <NoRights/>}
        </PageSurface>
      </PageWorkspace>
    </DashboardLayout>
  )
}


export { CertificateManagement };
